import { PhoneIcon } from '@heroicons/react/solid'
import React from "react";

export default function Nosotros(){
    return(
        <>
            <section className="imgNosotros"></section>
            <section>
                <div className="container mx-auto mb-10">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                        <div className="flex justify-center">
                            <div className="w-100 lg:w-9/12 shadow-lg border-inherit text-center">
                                <img src="/images/IMG-nosotros.jpg" className="-mt-48 lg:-mt-40 bg-white relative p-5" alt='Sobre nosotros viajes manguen'></img>
                                <p className="p-7 font-semibold text-green-400 text-3xl">¡Vive, conoce y disfruta!</p>
                            </div>
                        </div>
                        <div className="flex flex-col text-center space-y-6 lg:px-4 text-black mt-20">
                            <div className="flex flex-row justify-center">
                                <h1 className="font-bold text-green-400 text-3xl">Nosotros</h1>
                            </div>
                            <div className="flex flex-row">
                                <p className="pl-5">Somos una agencia de viajes dedicada a coleccionar momentos y crear historias con nuestros clientes</p>
                            </div>
                            <div className="flex flex-row">
                                <p className="pl-5">Ofrecemos promociones en paquetes todo incluido a los principales destinos turísticos de México y el mundo </p>
                            </div>
                            <div className='flex justify-center'>
                                <a href='https://wa.me/+5215527364548?&text=Hola.!!%20Quisiera%20reservar%20un%20viaje' target="_blank" rel="noreferrer">
                                    <div className='bg-regal-blue shadow-md text-white rounded-md font-semibold flex items-center py-8 text-xl h-10 xl:px-3 xl:items-center rounded-full w-60 h-auto border border-green justify-center'>
                                        Cotizar ahora
                                        <PhoneIcon className='h-12 w-12 px-2 text-green-400'/>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}